import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise/dist/ag-grid-enterprise.js";
import { inject, observer } from "mobx-react";
import React, { useState, useEffect } from "react";
import Select from "react-select";
import "./gainloss-transaction-screen.scss";
import RestEndPoint from "../../../common/RestEndPoint";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileExport,
  faSave,
  faSearch,
  faSync,
} from "@fortawesome/free-solid-svg-icons";
import AuditModal from "./gainloss-transaction-screen-audit-modal";
import { canUserViewIntegrationBtns } from "../utils";
import {
  JURISDICTION_PALINS_NORTH,
  JURISDICTION_PALINS_SOUTH
} from "../../../constants/gainLoss";
import { GainLossRoles } from "../store/rolesList";
import moment from "moment";
import { AppConstants } from "../../../common/APIConstants";

const TransactionScreen = inject(
  "GainLossTransactionScreenStore",
  "CommonStore"
)(
  observer((props) => {
    const {
      setSelectedJurisdiction,
      setSelectedDivision,
      setSelectedProductionMonth,
      screenColumnDefinitions,
      screenRowData,
      selectedData,
      setAuditPopUp,
    } = props.GainLossTransactionScreenStore;
    const [jurisdiction, setJurisdiction] = useState();
    const [division, setDivision] = useState();
    const [productionMonth, setProductionMonth] = useState();
    const [show, setShow] = useState(false);
    const [disable_eabs,setDisableEABS] = useState(false);
    const [disable_fbs,setDisableFBS] = useState(false);
    const [disable_vmac,setDisableVMAC] = useState(false);
    const [disable_vmac_ppa,setDisableVMACPPA] = useState(false);
    const [disableFlowCal, setDisableFlowCal] = useState(false)

    const gridRef = React.useRef();
    useEffect(() => {
      setColumnDef();
    }, []);
    useEffect(() => {
      async function fetchData() {
        const { CommonStore, GainLossTransactionScreenStore } = props;
        await GainLossTransactionScreenStore.setProductionMonths(CommonStore);
        const { selectedProductionMonth } = GainLossTransactionScreenStore;
        setProductionMonth(selectedProductionMonth);
      }
      fetchData();
    }, []);

    const setjurisdictionOptions = () => {
      const userRoles = RestEndPoint.getCurrentUserRoles();
      if (userRoles.includes("GainLossAdminRole")) {
        return [
          { value: "Plains - North", label: "Plains - North" },
          { value: "Plains - South", label: "Plains - South" },
        ];
      } else if (
        userRoles.includes("GainLossNorthDataEntryRole") ||
        userRoles.includes("GainLossNorthDistrictSignOffRole")
      ) {
        return [{ value: "Plains - North", label: "Plains - North" }];
      } else if (
        userRoles.includes("GainLossSouthDataEntryRole") ||
        userRoles.includes("GainLossSouthDistrictSignOffRole")
      ) {
        return [{ value: "Plains - South", label: "Plains - South" }];
      } else {
        return [];
      }
    };

    const setColumnDef = async () => {
      const { CommonStore, GainLossTransactionScreenStore } = props;
      const parentScreenName = props.path.split("/").pop();
      const currentScreen = props.CommonStore.screenDetails.filter(
        (x) => x.screen.name === parentScreenName
      );
      
      await GainLossTransactionScreenStore.setColumnDef(
        currentScreen,
        CommonStore
      );
    };

    const setGridOptions = () => {
      const { GainLossTransactionScreenStore } = props;
      return GainLossTransactionScreenStore.gridOptions;
    };

    const getTransactionData = async () => {
      if (jurisdiction && division) {
        setShow(true);
        const { CommonStore, GainLossTransactionScreenStore } = props;
        const parentScreenName = props.path.split("/").pop();
        const currentScreen = props.CommonStore.screenDetails.filter(
          (x) => x.screen.name === parentScreenName
        );
        await GainLossTransactionScreenStore.getScreenData(
          currentScreen,
          jurisdiction?.value ?? null,
          division?.value ?? null,
          productionMonth?.value ?? null,
          CommonStore
        );
      }
    };

    const formatColumnByJurisdiction = (event) => {
      const { GainLossTransactionScreenStore } = props;
      GainLossTransactionScreenStore.formatColumnByJurisdiction(event.value);
    };

    const onSelectionChanged = async (e) => {
      if (
        e.column.colId === "dataConfidence" &&
        (e.newValue != null || e.oldValue != null)
      ) {
        if (e.newValue != null && e.newValue) {
          e.data["dataConfidence"] = e.newValue;
          saveSelectedData(e);
        } else if (e.oldValue != null && e.oldValue) {
          e.data["dataConfidence"] = e.oldValue;
          saveSelectedData(e);
        }
      } else if (e.newValue != e.oldValue && e.newValue != null && e.newValue) {
        saveSelectedData(e);
      }
    };

    const saveSelectedData = async (e) => {
      const { GainLossTransactionScreenStore } = props;
      const { selectedData } = GainLossTransactionScreenStore;
      const currentUser = RestEndPoint.getCurrentUserName();
      const mstTimeToDisplay = new Date().toLocaleString("en-US", {
        timeZone: "America/Denver",
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
        hour12: true,
        hour: "2-digit",
        minute: "2-digit",
      });
      const mstTimeToStore = new Date().toLocaleString("en-US", {
        timeZone: "America/Denver",
      });
      e.data["lastSavedBy"] = currentUser;
      e.data["lastSavedDateTime"] = mstTimeToDisplay;
      const updatedRow = e.data;
      const upd = updatedRow.productionDate;
      const date = new Date(
        Number(updatedRow.productionDate.split("-")[1]),
        Number(updatedRow.productionDate.split("-")[0]),
        0
      )
        .getDate()
        .toString();
      updatedRow.productionDate =
        updatedRow.productionDate.split("-")[1] +
        "-" +
        updatedRow.productionDate.split("-")[0] +
        "-" +
        date +
        "T00:00:00.000";
      updatedRow.lastSavedDateTime = mstTimeToStore;
      const toUpdateRow = updatedRow;
      selectedData.push(toUpdateRow);
      e.data["productionDate"] = upd;
      e.data["lastSavedDateTime"] = mstTimeToDisplay;
      GainLossTransactionScreenStore.gridOptions.api.refreshCells();
    };

    const saveData = async () => {
      const { CommonStore, GainLossTransactionScreenStore } = props;
      await GainLossTransactionScreenStore.saveData(CommonStore);
      await refreshData();
    };

    const refreshData = async () => {
      await getTransactionData();
      const { CommonStore, GainLossTransactionScreenStore } = props;
      GainLossTransactionScreenStore.refreshData(CommonStore);
    };

    const exportToExcel = async () => {
      const { GainLossTransactionScreenStore } = props;
      const parentScreenName = props.path.split("/").pop();
      GainLossTransactionScreenStore.exportToExcel(parentScreenName);
    };

    const setDistrictData = async (event) => {
      const { CommonStore, GainLossTransactionScreenStore } = props;
      GainLossTransactionScreenStore.setDistrictData(CommonStore, event.value);
    };

    const getDistrictData = () => {
      const { GainLossTransactionScreenStore } = props;
      const { districtData } = GainLossTransactionScreenStore;
      return districtData;
    };

    const getProductionMonths = () => {
      const { GainLossTransactionScreenStore } = props;
      const { productionMonthData } = GainLossTransactionScreenStore;
      return productionMonthData;
    };

    const getContextMenuItems = (e) => {
      const { CommonStore, GainLossTransactionScreenStore } = props;
      var result = [
        {
          name: "Show Audit Data",
          action: async () => {
            const auditData = await GainLossTransactionScreenStore.getAuditData(
              CommonStore,
              e.node.data
            );
            setAuditPopUp(true);
          },
        },
      ];
      return result;
    };

    const getShowAuditPopUp = () => {
      const { GainLossTransactionScreenStore } = props;
      const { showAuditPopUp } = GainLossTransactionScreenStore;
      return showAuditPopUp;
    };

    const FetchEABS = async () => {
      setDisableEABS(true);

      const email = RestEndPoint.getCurrentUserEmail();
      const { CommonStore,GainLossTransactionScreenStore } = props;
      CommonStore.toggleLoader();
      await GainLossTransactionScreenStore.FetchEABS(email);
      CommonStore.toggleLoader();

      //180000 - 3 min
      setTimeout(() => setDisableEABS(false), 180000);

    };

    const FetchFBS = async () => {
      setDisableFBS(true);

      const email = RestEndPoint.getCurrentUserEmail();
      const { CommonStore,GainLossTransactionScreenStore } = props;
      CommonStore.toggleLoader();
      await GainLossTransactionScreenStore.FetchFBS(email);
      CommonStore.toggleLoader();

      //180000 - 3 min
      setTimeout(() => setDisableFBS(false), 180000);
    };

    const FetchVMAC = async (isVmacPPA) => {
      const email = RestEndPoint.getCurrentUserEmail();
      const { CommonStore,GainLossTransactionScreenStore } = props;
      const splittedProdMonth = productionMonth.label.split('-')
      const month = Number(splittedProdMonth[0])
      const year = Number(splittedProdMonth[1])
      
      if (isVmacPPA && month === 1 && year === moment().year()) {
        window.toastr.info(AppConstants.GAINLOSS_VMACS_PPA_CURRENT_YEAR_JAN_MONTH_EXCEPTION)
      } else if (isVmacPPA) {
        setDisableVMACPPA(true)
        CommonStore.toggleLoader();
        await GainLossTransactionScreenStore.FetchVMAC(email, isVmacPPA);
        CommonStore.toggleLoader();
        //180000 - 3 min
        setTimeout(() => setDisableVMACPPA(false), 180000);
      } else {
        setDisableVMAC(true)
        CommonStore.toggleLoader();
        await GainLossTransactionScreenStore.FetchVMAC(email, isVmacPPA);
        CommonStore.toggleLoader();
        //180000 - 3 min
        setTimeout(() => setDisableVMAC(false), 180000);
      }
    };

    const fetchFlowCal = async () => {
      const { CommonStore, GainLossTransactionScreenStore } = props;

      setDisableFlowCal(true);
      const email = RestEndPoint.getCurrentUserEmail();
      const userName = RestEndPoint.getCurrentUserName();

      CommonStore.toggleLoader();
      await GainLossTransactionScreenStore.FetchFlowCal(email,userName);
      CommonStore.toggleLoader();

      //180000 - 3 min
      setTimeout(() => setDisableFlowCal(false), 180000);
    };

    const FetchHighWire = async () => {
      const email = RestEndPoint.getCurrentUserEmail();
      const { CommonStore,GainLossTransactionScreenStore } = props;
      CommonStore.toggleLoader();
      await GainLossTransactionScreenStore.FetchHW(email);
      CommonStore.toggleLoader();

    };

    return (
      <>
        <div className="col-md-12 transactions-screen-container">
          <div className="container cb-title-container">
            <h3 className="cb-title">{"Transaction Screen"}</h3>
          </div>
          <div className="col-md-12 filters-container">
            <div className="transactions-filter-container">
              <div className="field-label">{"Jurisdiction"}</div>
              <Select
                className="jurisdiction-field field"
                options={setjurisdictionOptions()}
                value={jurisdiction}
                onChange={(event) => {
                  setShow(false);
                  setDivision([]);
                  setJurisdiction(event);
                  setSelectedJurisdiction(event);
                  setDistrictData(event);
                  formatColumnByJurisdiction(event);
                }}
              />
            </div>
            <div className="transactions-filter-container">
              <div className="field-label">{"Division/District"}</div>
              <Select
                className="input-type-field field"
                options={getDistrictData()}
                value={division}
                onChange={(event) => {
                  setShow(false);
                  setDivision(event);
                  setSelectedDivision(event);
                }}
              />
            </div>
            <div className="transactions-filter-container">
              <div className="field-label">{"Production Month"}</div>
              <Select
                className="input-type-field field"
                options={getProductionMonths()}
                value={productionMonth}
                onChange={(event) => {
                  setProductionMonth(event);
                  setSelectedProductionMonth(event);
                }}
              />
            </div>
            <div className="transactions-filter-container">
              <button
                type="search"
                className="btn btn-primary btn-grid active"
                aria-expanded="false"
                disabled={
                  jurisdiction?.value?.length === 0 ||
                  jurisdiction?.value?.length === undefined ||
                  division?.value?.length === 0 ||
                  division?.value?.length === undefined
                }
                onClick={getTransactionData}
              >
                <FontAwesomeIcon icon={faSearch} />
                Search
              </button>
            </div>
          </div>
          <div className="col-md-12 table-container">
            {jurisdiction?.value?.length > 0 &&
            division?.value?.length > 0 &&
            show ? (
              <>
                <div
                  id={"gainloss-transactions"}
                  style={{ width: "100%" }}
                  className="col-md-12 ag-fresh"
                >
                  <div
                    className="ag-theme-balham grid-container"
                    style={{
                      font: ".8em Segoe UI, sans-serif",
                      margin: "15px",
                    }}
                  >
                    <AgGridReact
                      gridOptions={setGridOptions()}
                      columnDefs={
                        screenColumnDefinitions.GainLossTransactionScreen
                      }
                      rowData={screenRowData.TransactionData}
                      onCellValueChanged={onSelectionChanged}
                      suppressContextMenu={false}
                      getContextMenuItems={getContextMenuItems}
                    ></AgGridReact>
                  </div>
                </div>
                <div className="action-toolbar">
                  {canUserViewIntegrationBtns(jurisdiction.value) &&
                    jurisdiction.value === JURISDICTION_PALINS_NORTH && (
                      <>
                        <button
                          type="button"
                          className="btn btn-primary btn-grid active"
                          aria-expanded="false"
                          onClick={FetchHighWire}
                        >
                          <FontAwesomeIcon icon={faSync} /> {"Fetch Highwire"}
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary btn-grid active"
                          aria-expanded="false"
                          disabled={disable_eabs}
                          onClick={FetchEABS}
                        >
                          <FontAwesomeIcon icon={faSync} /> {"Fetch EABS"}
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary btn-grid active"
                          aria-expanded="false"
                          disabled={disable_fbs}
                          onClick={FetchFBS}
                        >
                          <FontAwesomeIcon icon={faSync} /> {"Fetch FBS"}
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary btn-grid active"
                          aria-expanded="false"
                          disabled={disableFlowCal}
                          onClick={fetchFlowCal}
                        >
                          <FontAwesomeIcon icon={faSync} /> {"Fetch FlowCal"}
                        </button>
                      </>
                    )}
                  {canUserViewIntegrationBtns(jurisdiction.value) &&
                    jurisdiction.value === JURISDICTION_PALINS_SOUTH && (
                      <>
                        <button
                          type="button"
                          className="btn btn-primary btn-grid active"
                          aria-expanded="false"
                          disabled={disable_vmac}
                          onClick={() => FetchVMAC(false)}
                        >
                          <FontAwesomeIcon icon={faSync} /> {"Fetch VMACS"}
                        </button>
                      </>
                    )}
                    {RestEndPoint.checkCurrentUserHasRole(GainLossRoles.GAINLOSS_ADMIN) &&
                      jurisdiction.value === JURISDICTION_PALINS_SOUTH && (
                        <>
                          <button
                            type="button"
                            className="btn btn-primary btn-grid active btn-fit-content"
                            aria-expanded="false"
                            disabled={disable_vmac_ppa}
                            onClick={() => FetchVMAC(true)}
                          >
                            <FontAwesomeIcon icon={faSync} /> {"Fetch VMACS for PPAs"}
                          </button>
                        </>
                      )}
                  <button
                    type="button"
                    className="btn btn-primary btn-grid active"
                    aria-expanded="false"
                    disabled={selectedData.length === 0}
                    onClick={saveData}
                  >
                    <FontAwesomeIcon icon={faSave} /> {"Save/Submit"}
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary btn-grid active"
                    aria-expanded="false"
                    onClick={refreshData}
                  >
                    <FontAwesomeIcon icon={faSync} /> {"Refresh/Cancel"}
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary btn-grid active"
                    aria-expanded="false"
                    onClick={exportToExcel}
                  >
                    <FontAwesomeIcon icon={faFileExport} /> {"Export"}
                  </button>
                </div>
                {getShowAuditPopUp() && <AuditModal />}
              </>
            ) : (
              <div className="instruction">
                Please select Jurisdiction and Division to retrieve data
              </div>
            )}
          </div>
        </div>
      </>
    );
  })
);

export default TransactionScreen;
